import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useOccDisplayText } from '../../../context/occ/hooks/use-occ-display-text';
import { appendDisplayTextLabelPart } from '../../../utils/display-text-utils';
import { DisplayText } from '../../display-text/display-text';
import { LabelType } from './types/type';
const b = bemClassBuilder('v-label');
/**
 * Renders a label or legend element.
 */
export const Label = observer(props => {
    const { form: formDisplayText } = useOccDisplayText();
    const { text, optional, style } = props;
    const optionalSuffixPart = {
        text: formDisplayText.fieldOptionalSuffix,
        className: b.element('optional-suffix')
    };
    const displayTextLabel = optional ? appendDisplayTextLabelPart(text, optionalSuffixPart) : text;
    const displayTextClassName = b.element('text');
    const className = b.block({ style });
    if (props.type === LabelType.Legend) {
        return (_jsx("legend", Object.assign({ className: className }, { children: _jsx(DisplayText, { label: displayTextLabel, className: displayTextClassName }) })));
    }
    return (_jsx("label", Object.assign({ className: className, htmlFor: props.elementId }, { children: _jsx(DisplayText, { label: displayTextLabel, className: displayTextClassName }) })));
});
Label.displayName = 'Label';
